import type { TicketingSubmittersLocationsPayload } from '../pages/TicketingAnalytics/types';

export const TICKETING_SUBMITTERS_LOCATIONS_MOCK: TicketingSubmittersLocationsPayload = {
	ticketsByRole: {
		title: 'Tickets by Role',
		description: 'Total tickets submitted per Navigator Role, highest to lowest',
		roles: [
			{ name: 'Supervisor', count: 512, percentage: 39.9 },
			{ name: 'Navigator User', count: 318, percentage: 24.8 },
			{ name: 'Super User', count: 164, percentage: 12.8 },
			{ name: 'Market Lead', count: 142, percentage: 11.1 },
			{ name: 'COE Analyst', count: 86, percentage: 6.7 },
			{ name: 'Region Lead', count: 62, percentage: 4.8 },
		],
	},
	topRepeatSubmitters: {
		title: 'Top Repeat Submitters',
		description: 'Top 10 users by total tickets submitted',
		submitters: [
			{
				user: 'T. Ramirez',
				ticketsSubmitted: 28,
				ticketsClosed: 24,
				ticketsOpen: 4,
				resolutionRate: 85.7,
				averageResolutionTime: 21.4,
				topCategory: { name: 'System Issue', count: 12 },
				navigatorRole: 'Supervisor',
				location: 'Sioux Falls SD',
			},
			{
				user: 'L. Nguyen',
				ticketsSubmitted: 24,
				ticketsClosed: 21,
				ticketsOpen: 3,
				resolutionRate: 87.5,
				averageResolutionTime: 19.8,
				topCategory: { name: 'Access Request', count: 9 },
				navigatorRole: 'Supervisor',
				location: 'Chicago IL',
			},
			{
				user: 'B. Jackson',
				ticketsSubmitted: 21,
				ticketsClosed: 17,
				ticketsOpen: 4,
				resolutionRate: 81.0,
				averageResolutionTime: 26.2,
				topCategory: { name: 'System Issue', count: 8 },
				navigatorRole: 'Navigator User',
				location: 'Dallas TX',
			},
			{
				user: 'P. Kowalski',
				ticketsSubmitted: 19,
				ticketsClosed: 17,
				ticketsOpen: 2,
				resolutionRate: 89.5,
				averageResolutionTime: 17.6,
				topCategory: { name: 'Reporting', count: 7 },
				navigatorRole: 'Super User',
				location: 'Milwaukee WI',
			},
			{
				user: 'M. Flores',
				ticketsSubmitted: 17,
				ticketsClosed: 14,
				ticketsOpen: 3,
				resolutionRate: 82.4,
				averageResolutionTime: 24.9,
				topCategory: { name: 'System Issue', count: 7 },
				navigatorRole: 'Supervisor',
				location: 'Houston TX',
			},
			{
				user: 'D. Schmidt',
				ticketsSubmitted: 16,
				ticketsClosed: 14,
				ticketsOpen: 2,
				resolutionRate: 87.5,
				averageResolutionTime: 22.0,
				topCategory: { name: 'Reporting', count: 6 },
				navigatorRole: 'Market Lead',
				location: 'Des Moines IA',
			},
			{
				user: 'A. Brooks',
				ticketsSubmitted: 14,
				ticketsClosed: 11,
				ticketsOpen: 3,
				resolutionRate: 78.6,
				averageResolutionTime: 29.3,
				topCategory: { name: 'Training', count: 5 },
				navigatorRole: 'Navigator User',
				location: 'Atlanta GA',
			},
			{
				user: 'S. Olsen',
				ticketsSubmitted: 13,
				ticketsClosed: 12,
				ticketsOpen: 1,
				resolutionRate: 92.3,
				averageResolutionTime: 15.1,
				topCategory: { name: 'Hardware', count: 4 },
				navigatorRole: 'Supervisor',
				location: 'Fargo ND',
			},
			{
				user: 'C. Vargas',
				ticketsSubmitted: 12,
				ticketsClosed: 10,
				ticketsOpen: 2,
				resolutionRate: 83.3,
				averageResolutionTime: 20.5,
				topCategory: { name: 'Reporting', count: 5 },
				navigatorRole: 'COE Analyst',
				location: 'Phoenix AZ',
			},
			{
				user: 'R. Adeyemi',
				ticketsSubmitted: 11,
				ticketsClosed: 9,
				ticketsOpen: 2,
				resolutionRate: 81.8,
				averageResolutionTime: 23.7,
				topCategory: { name: 'System Issue', count: 4 },
				navigatorRole: 'Super User',
				location: 'Detroit MI',
			},
		],
	},
	topLocationSubmitters: {
		title: 'Top Location Submitters',
		description: 'Top 10 locations by total tickets submitted',
		locations: [
			{
				location: 'Chicago IL',
				ticketsSubmitted: 142,
				ticketsClosed: 116,
				ticketsOpen: 26,
				resolutionRate: 81.7,
				averageResolutionTime: 24.6,
				topCategory: { name: 'System Issue', count: 49 },
			},
			{
				location: 'Dallas TX',
				ticketsSubmitted: 118,
				ticketsClosed: 99,
				ticketsOpen: 19,
				resolutionRate: 83.9,
				averageResolutionTime: 23.2,
				topCategory: { name: 'System Issue', count: 41 },
			},
			{
				location: 'Houston TX',
				ticketsSubmitted: 104,
				ticketsClosed: 87,
				ticketsOpen: 17,
				resolutionRate: 83.7,
				averageResolutionTime: 25.5,
				topCategory: { name: 'System Issue', count: 36 },
			},
			{
				location: 'Atlanta GA',
				ticketsSubmitted: 96,
				ticketsClosed: 82,
				ticketsOpen: 14,
				resolutionRate: 85.4,
				averageResolutionTime: 32.1,
				topCategory: { name: 'System Issue', count: 31 },
			},
			{
				location: 'Detroit MI',
				ticketsSubmitted: 92,
				ticketsClosed: 77,
				ticketsOpen: 15,
				resolutionRate: 83.7,
				averageResolutionTime: 28.3,
				topCategory: { name: 'System Issue', count: 30 },
			},
			{
				location: 'Columbus OH',
				ticketsSubmitted: 88,
				ticketsClosed: 75,
				ticketsOpen: 13,
				resolutionRate: 85.2,
				averageResolutionTime: 26.9,
				topCategory: { name: 'Reporting', count: 24 },
			},
			{
				location: 'Sioux Falls SD',
				ticketsSubmitted: 88,
				ticketsClosed: 63,
				ticketsOpen: 25,
				resolutionRate: 71.6,
				averageResolutionTime: 35.8,
				topCategory: { name: 'System Issue', count: 34 },
			},
			{
				location: 'Phoenix AZ',
				ticketsSubmitted: 81,
				ticketsClosed: 69,
				ticketsOpen: 12,
				resolutionRate: 85.2,
				averageResolutionTime: 29.7,
				topCategory: { name: 'Reporting', count: 23 },
			},
			{
				location: 'Milwaukee WI',
				ticketsSubmitted: 73,
				ticketsClosed: 63,
				ticketsOpen: 10,
				resolutionRate: 86.3,
				averageResolutionTime: 22.4,
				topCategory: { name: 'Reporting', count: 21 },
			},
			{
				location: 'Charlotte NC',
				ticketsSubmitted: 71,
				ticketsClosed: 62,
				ticketsOpen: 9,
				resolutionRate: 87.3,
				averageResolutionTime: 27.8,
				topCategory: { name: 'Access Request', count: 22 },
			},
		],
	},
	masterLocationTable: {
		title: 'Master Location Table',
		searchable: true,
		searchPlaceholder: 'Search locations or SAP ID',
		locations: [
			{
				location: 'Atlanta GA',
				sapId: 1187,
				ticketsSubmitted: 96,
				ticketsClosed: 82,
				ticketsOpen: 14,
				resolutionRate: 85.4,
				averageResolutionTime: 32.1,
				topCategory: { name: 'System Issue', count: 31 },
			},
			{
				location: 'Charlotte NC',
				sapId: 1304,
				ticketsSubmitted: 71,
				ticketsClosed: 62,
				ticketsOpen: 9,
				resolutionRate: 87.3,
				averageResolutionTime: 27.8,
				topCategory: { name: 'Access Request', count: 22 },
			},
			{
				location: 'Chicago IL',
				sapId: 1042,
				ticketsSubmitted: 142,
				ticketsClosed: 116,
				ticketsOpen: 26,
				resolutionRate: 81.7,
				averageResolutionTime: 24.6,
				topCategory: { name: 'System Issue', count: 49 },
			},
			{
				location: 'Columbus OH',
				sapId: 1266,
				ticketsSubmitted: 88,
				ticketsClosed: 75,
				ticketsOpen: 13,
				resolutionRate: 85.2,
				averageResolutionTime: 26.9,
				topCategory: { name: 'Reporting', count: 24 },
			},
			{
				location: 'Dallas TX',
				sapId: 1095,
				ticketsSubmitted: 118,
				ticketsClosed: 99,
				ticketsOpen: 19,
				resolutionRate: 83.9,
				averageResolutionTime: 23.2,
				topCategory: { name: 'System Issue', count: 41 },
			},
			{
				location: 'Denver CO',
				sapId: 1421,
				ticketsSubmitted: 64,
				ticketsClosed: 56,
				ticketsOpen: 8,
				resolutionRate: 87.5,
				averageResolutionTime: 30.4,
				topCategory: { name: 'Training', count: 18 },
			},
			{
				location: 'Des Moines IA',
				sapId: 1358,
				ticketsSubmitted: 59,
				ticketsClosed: 52,
				ticketsOpen: 7,
				resolutionRate: 88.1,
				averageResolutionTime: 21.7,
				topCategory: { name: 'Reporting', count: 17 },
			},
			{
				location: 'Detroit MI',
				sapId: 1133,
				ticketsSubmitted: 92,
				ticketsClosed: 77,
				ticketsOpen: 15,
				resolutionRate: 83.7,
				averageResolutionTime: 28.3,
				topCategory: { name: 'System Issue', count: 30 },
			},
			{
				location: 'Fargo ND',
				sapId: 1492,
				ticketsSubmitted: 38,
				ticketsClosed: 34,
				ticketsOpen: 4,
				resolutionRate: 89.5,
				averageResolutionTime: 18.9,
				topCategory: { name: 'Hardware', count: 11 },
			},
			{
				location: 'Houston TX',
				sapId: 1108,
				ticketsSubmitted: 104,
				ticketsClosed: 87,
				ticketsOpen: 17,
				resolutionRate: 83.7,
				averageResolutionTime: 25.5,
				topCategory: { name: 'System Issue', count: 36 },
			},
			{
				location: 'Milwaukee WI',
				sapId: 1217,
				ticketsSubmitted: 73,
				ticketsClosed: 63,
				ticketsOpen: 10,
				resolutionRate: 86.3,
				averageResolutionTime: 22.4,
				topCategory: { name: 'Reporting', count: 21 },
			},
			{
				location: 'Omaha NE',
				sapId: 1376,
				ticketsSubmitted: 67,
				ticketsClosed: 58,
				ticketsOpen: 9,
				resolutionRate: 86.6,
				averageResolutionTime: 26.1,
				topCategory: { name: 'Access Request', count: 19 },
			},
			{
				location: 'Phoenix AZ',
				sapId: 1245,
				ticketsSubmitted: 81,
				ticketsClosed: 69,
				ticketsOpen: 12,
				resolutionRate: 85.2,
				averageResolutionTime: 29.7,
				topCategory: { name: 'Reporting', count: 23 },
			},
			{
				location: 'Portland OR',
				sapId: 1463,
				ticketsSubmitted: 47,
				ticketsClosed: 41,
				ticketsOpen: 6,
				resolutionRate: 87.2,
				averageResolutionTime: 24.0,
				topCategory: { name: 'Training', count: 13 },
			},
			{
				location: 'Seattle WA',
				sapId: 1439,
				ticketsSubmitted: 56,
				ticketsClosed: 48,
				ticketsOpen: 8,
				resolutionRate: 85.7,
				averageResolutionTime: 27.2,
				topCategory: { name: 'System Issue', count: 16 },
			},
			{
				location: 'Sioux Falls SD',
				sapId: 1284,
				ticketsSubmitted: 88,
				ticketsClosed: 63,
				ticketsOpen: 25,
				resolutionRate: 71.6,
				averageResolutionTime: 35.8,
				topCategory: { name: 'System Issue', count: 34 },
			},
		],
	},
};

